import { CTASection } from '../components/UI';
import { PageHero } from '../components/UI';

// ── Flag image map: country name → /flags/btn_xxx.png (35 flags) ──
const flagImg = {
  // Batch 1 (original uploads)
  'Australia':       '/flags/btn_australia.png',
  'Austria':         '/flags/btn_austria.png',
  'Belgium':         '/flags/btn_belgium.png',
  'Brazil':          '/flags/btn_brazil.png',
  'Canada':          '/flags/btn_canada.png',
  'Greece':          '/flags/btn_greece.png',
  'Hungary':         '/flags/btn_hungary.png',
  'Ireland':         '/flags/btn_ireland.png',
  'Italy':           '/flags/btn_italy.png',
  'Japan':           '/flags/btn_japan.png',
  'Malaysia':        '/flags/btn_malaysia.png',
  'Portugal':        '/flags/btn_portugal.png',
  'Singapore':       '/flags/btn_singapore.png',
  'South Africa':    '/flags/btn_south_africa.png',
  'South Korea':     '/flags/btn_south_korea.png',
  'Spain':           '/flags/btn_spain.png',
  'Sweden':          '/flags/btn_sweden.png',
  'Switzerland':     '/flags/btn_switzerland.png',
  'Turkey':          '/flags/btn_turkey.png',
  // Batch 2 (new uploads)
  'Argentina':       '/flags/btn_argentina.png',
  'China':           '/flags/btn_china.png',
  'Czech Republic':  '/flags/btn_czech_republic.png',
  'Denmark':         '/flags/btn_denmark.png',
  'Finland':         '/flags/btn_finland.png',
  'France':          '/flags/btn_france.png',
  'Germany':         '/flags/btn_germany.png',
  'Mexico':          '/flags/btn_mexico.png',
  'Netherlands':     '/flags/btn_netherlands.png',
  'New Zealand':     '/flags/btn_new_zealand.png',
  'Norway':          '/flags/btn_norway.png',
  'Pakistan':        '/flags/btn_pakistan.png',
  'Poland':          '/flags/btn_poland.png',
  'UAE':             '/flags/btn_uae.png',
  'UK':              '/flags/btn_united_kingdom.png',
  'USA':             '/flags/btn_usa.png',
};

// Emoji fallbacks for countries without uploaded flag images
const emojiFlag = {
  'Lithuania':   '🇱🇹',
  'Cyprus':      '🇨🇾',
  'Luxembourg':  '🇱🇺',
  'Thailand':    '🇹🇭',
  'Georgia':     '🇬🇪',
  'Russia':      '🇷🇺',
  'Croatia':     '🇭🇷',
  'Latvia':      '🇱🇻',
  'Monaco':      '🇲🇨',
};

// Featured top 4 destinations with full detail
const topDestinations = [
  {
    name: 'UK',
    tagline: 'World-Class Education, Graduate Route Visa',
    desc: 'Oxford, Cambridge, UCL and 130+ universities. The Graduate Route visa lets international students stay and work for 2–3 years post-graduation.',
    courses: ['Business & Management','Computer Science','Law','Medicine','Engineering'],
    visaTag: 'Graduate Route',
  },
  {
    name: 'Canada',
    tagline: 'Study, Work, and Build a Life',
    desc: "PGWP and clear Express Entry PR pathways after graduation. Canada is the #1 destination for students seeking not just a degree, but a future.",
    courses: ['IT & Technology','Healthcare','Business','Engineering','Arts & Humanities'],
    visaTag: 'PGWP',
  },
  {
    name: 'Australia',
    tagline: 'High Quality of Life, Open Work Rights',
    desc: "Subclass 485 post-study visa allows 2–4 years of work after graduation. Work 48 hours per fortnight during studies.",
    courses: ['Nursing & Health','Agriculture','Education','Architecture','Finance'],
    visaTag: '485 Visa',
  },
  {
    name: 'Germany',
    tagline: 'Near-Zero Tuition Public Universities',
    desc: 'Opportunity Card and Job Seeker visa. German public universities charge little to no tuition fees for international students.',
    courses: ['Engineering','Sciences','Computer Science','MBA','Architecture'],
    visaTag: 'Opportunity Card',
  },
];

// All 35+ countries by region (with real flag images)
const regions = [
  {
    label: 'UK & Ireland',
    countries: [
      { name: 'UK',      tag: 'Student Visa' },
      { name: 'Ireland', tag: 'Study Visa' },
    ],
  },
  {
    label: 'North America & Latin America',
    countries: [
      { name: 'USA',           tag: 'F-1 Visa' },
      { name: 'Canada',        tag: 'SDS · Non-SDS' },
      { name: 'Mexico',        tag: 'Student Visa' },
      { name: 'Brazil',        tag: 'Student Visa' },
      { name: 'Argentina',     tag: 'Student Visa' },
    ],
  },
  {
    label: 'Australia & Pacific',
    countries: [
      { name: 'Australia',   tag: 'Student Visa' },
      { name: 'New Zealand', tag: 'Student Visa' },
    ],
  },
  {
    label: 'Europe',
    countries: [
      { name: 'Germany',        tag: 'National Visa' },
      { name: 'France',         tag: 'VLS-TS' },
      { name: 'Sweden',         tag: 'Residence Permit' },
      { name: 'Finland',        tag: 'Residence Permit' },
      { name: 'Norway',         tag: 'Residence Permit' },
      { name: 'Denmark',        tag: 'Residence Permit' },
      { name: 'Netherlands',    tag: 'MVV · TEV' },
      { name: 'Austria',        tag: 'National Visa D' },
      { name: 'Switzerland',    tag: 'National Visa' },
      { name: 'Italy',          tag: 'Student Visa D' },
      { name: 'Spain',          tag: 'Student Visa' },
      { name: 'Belgium',        tag: 'Student Visa' },
      { name: 'Portugal',       tag: 'Student Visa' },
      { name: 'Poland',         tag: 'National Visa D' },
      { name: 'Czech Republic', tag: 'Long-stay Visa' },
      { name: 'Hungary',        tag: 'Student Visa' },
      { name: 'Greece',         tag: 'National Visa D' },
      { name: 'Lithuania',      tag: 'National Visa D' },
      { name: 'Cyprus',         tag: 'Student Visa' },
      { name: 'Croatia',        tag: 'National Visa D' },
      { name: 'Latvia',         tag: 'Long-stay Visa' },
      { name: 'Luxembourg',     tag: 'Student Visa' },
      { name: 'Monaco',         tag: 'Student Visa' },
    ],
  },
  {
    label: 'Asia & Middle East',
    countries: [
      { name: 'UAE',          tag: 'Student Visa' },
      { name: 'Singapore',    tag: 'Student Pass' },
      { name: 'Malaysia',     tag: 'Student Pass' },
      { name: 'Japan',        tag: 'Student Visa' },
      { name: 'South Korea',  tag: 'D-2 Visa' },
      { name: 'China',        tag: 'X1 · X2 Visa' },
      { name: 'Thailand',     tag: 'ED Visa' },
      { name: 'Turkey',       tag: 'Student Visa' },
    ],
  },
  {
    label: 'Africa & Other',
    countries: [
      { name: 'South Africa', tag: 'Study Visa' },
      { name: 'Georgia',      tag: 'Student Visa' },
      { name: 'Russia',       tag: 'Student Visa' },
    ],
  },
];

// Renders a flag — uploaded image if available, else emoji
function FlagDisplay({ name, className = "w-full h-full object-cover" }) {
  if (flagImg[name]) {
    return (
      <img
        src={flagImg[name]}
        alt={`${name} flag`}
        className={className}
        draggable="false"
      />
    );
  }
  // emoji fallback
  return (
    <div className="w-full h-full flex items-center justify-center text-5xl select-none">
      {emojiFlag[name] || '🌍'}
    </div>
  );
}

// Top featured destination card (horizontal layout)
function TopDestCard({ dest, i, setPage }) {
  const wa = () => window.open(`https://wa.me/923084715628?text=Hi, I want to enquire about Study in ${encodeURIComponent(dest.name)}`, '_blank');
  const even = i % 2 === 0;

  return (
    <div className={`flex flex-col ${even ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-8 items-center bg-gray-50 border border-gray-100 rounded-3xl p-6 lg:p-8 hover:shadow-[0_16px_48px_rgba(11,31,58,0.1)] hover:border-teal/20 transition-all duration-300`}>
      {/* Flag image */}
      <div className="w-full lg:w-56 h-48 lg:h-44 flex-shrink-0 rounded-2xl overflow-hidden shadow-lg">
        <FlagDisplay name={dest.name} className="w-full h-full object-cover" />
      </div>

      {/* Content */}
      <div className="flex-1">
        <span className="inline-block text-[0.68rem] font-bold tracking-widest uppercase text-teal bg-teal/10 px-3 py-1 rounded-full mb-3">
          {dest.name}
        </span>
        <h3 className="font-display text-2xl lg:text-3xl text-navy font-semibold mb-2 leading-snug">{dest.tagline}</h3>
        <p className="text-gray-500 text-sm leading-relaxed mb-4">{dest.desc}</p>

        {/* Course tags */}
        <div className="flex flex-wrap gap-2 mb-5">
          {dest.courses.map(c => (
            <span key={c} className="text-xs font-semibold text-teal bg-teal/8 border border-teal/15 px-2.5 py-1 rounded-full">
              {c}
            </span>
          ))}
        </div>

        <div className="flex flex-wrap gap-3 items-center">
          <button onClick={wa} className="btn-primary text-sm px-5 py-2.5">
            Apply for {dest.name}
            <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3"/>
            </svg>
          </button>
          <span className="flex items-center gap-1.5 text-sm text-gray-400 font-medium">
            <span className="w-2 h-2 rounded-full bg-emerald-400 inline-block"></span>
            {dest.visaTag}
          </span>
        </div>
      </div>
    </div>
  );
}

// Small country card for the grid (uses real flag image if available)
function CountryCard({ name, tag }) {
  const wa = () => window.open(`https://wa.me/923084715628?text=Hi, I want to enquire about Study in ${encodeURIComponent(name)}`, '_blank');
  const hasImage = !!flagImg[name];

  return (
    <button
      onClick={wa}
      className="group bg-white border border-gray-100 rounded-2xl overflow-hidden hover:border-teal/50 hover:-translate-y-1.5 hover:shadow-[0_12px_32px_rgba(11,31,58,0.1)] transition-all duration-250 text-left flex flex-col"
    >
      {/* Flag area */}
      <div className="relative h-28 w-full overflow-hidden bg-gray-100 flex-shrink-0">
        {hasImage ? (
          <img
            src={flagImg[name]}
            alt={`${name} flag`}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
            draggable="false"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-5xl select-none bg-gradient-to-br from-gray-50 to-gray-100">
            {emojiFlag[name] || '🌍'}
          </div>
        )}
        {/* Hover overlay */}
        <div className="absolute inset-0 bg-teal/0 group-hover:bg-teal/10 transition-colors duration-300"></div>
      </div>

      {/* Label */}
      <div className="px-3 py-3 flex-1">
        <div className="font-body font-bold text-navy text-sm leading-tight mb-1">{name}</div>
        <div className="text-[0.65rem] font-semibold text-teal">{tag}</div>
      </div>
    </button>
  );
}

export default function Destinations({ setPage }) {
  return (
    <div>
      <PageHero
        breadcrumb="Destinations"
        title="35+ Study Destinations"
        subtitle="We support student visa applications across 35 countries. Every destination is supported end-to-end — admission, visa, and accommodation."
      />

      {/* ── TOP FEATURED DESTINATIONS ── */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-12">
            <span className="section-tag">Most Popular</span>
            <h2 className="font-display text-4xl text-navy font-semibold mt-1">Top Destinations</h2>
          </div>
          <div className="flex flex-col gap-6">
            {topDestinations.map((dest, i) => (
              <TopDestCard key={dest.name} dest={dest} i={i} setPage={setPage} />
            ))}
          </div>
        </div>
      </section>

      {/* ── ALL COUNTRIES BY REGION ── */}
      <section className="py-16 bg-cream">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-12">
            <span className="section-tag">All Destinations</span>
            <h2 className="font-display text-4xl text-navy font-semibold mt-1">35+ Countries by Region</h2>
            <p className="text-gray-500 mt-3 max-w-lg mx-auto text-sm">Click any country to send us a WhatsApp enquiry and we'll get back to you within 2 hours.</p>
          </div>

          {regions.map(region => (
            <div key={region.label} className="mb-10">
              <div className="flex items-center gap-3 mb-5">
                <div className="h-px flex-1 bg-gray-200 max-w-[40px]"></div>
                <h4 className="font-body font-bold text-xs tracking-[0.18em] uppercase text-gray-400">{region.label}</h4>
                <div className="h-px flex-1 bg-gray-200"></div>
              </div>
              <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-8 xl:grid-cols-10 gap-3">
                {region.countries.map(c => (
                  <CountryCard key={c.name} name={c.name} tag={c.tag} />
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ── COMPARISON TABLE ── */}
      <section className="py-14 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-10">
            <span className="section-tag">Quick Comparison</span>
            <h2 className="font-display text-4xl text-navy font-semibold mt-1">At a Glance</h2>
          </div>
          <div className="overflow-x-auto rounded-2xl border border-gray-200 shadow-card">
            <table className="w-full text-sm">
              <thead>
                <tr className="bg-navy text-white">
                  <th className="text-left px-5 py-4 font-semibold min-w-[120px]">Country</th>
                  <th className="text-left px-5 py-4 font-semibold">Tuition Range</th>
                  <th className="text-left px-5 py-4 font-semibold">Work Rights</th>
                  <th className="text-left px-5 py-4 font-semibold">Post-Study Visa</th>
                  <th className="text-left px-5 py-4 font-semibold">PR Pathway</th>
                </tr>
              </thead>
              <tbody>
                {[
                  { name: 'UK',          tuition: '£10K–£38K/yr',       work: '20 hrs/week',          psv: 'Graduate Route (2–3 yrs)',    pr: 'Skilled Worker Visa',      imgFlag: '/flags/btn_united_kingdom.png' },
                  { name: 'Canada',      tuition: 'CAD $15K–$35K/yr',   work: '20 hrs/week',          psv: 'PGWP (1–3 yrs)',             pr: 'Express Entry / PNP',      imgFlag: '/flags/btn_canada.png' },
                  { name: 'Australia',   tuition: 'AUD $20K–$45K/yr',   work: '48 hrs/fortnight',     psv: 'Subclass 485 (2–4 yrs)',     pr: 'Skilled Migration',         imgFlag: '/flags/btn_australia.png' },
                  { name: 'USA',         tuition: 'USD $20K–$60K/yr',   work: '20 hrs/week (campus)', psv: 'OPT/STEM OPT (up to 3 yrs)', pr: 'Green Card (complex)',      imgFlag: '/flags/btn_usa.png' },
                  { name: 'Germany',     tuition: '€0–€3K/yr',          work: '20 hrs/week',          psv: 'Job Seeker Visa (18 months)', pr: 'Settlement Permit',        imgFlag: '/flags/btn_germany.png' },
                  { name: 'Sweden',      tuition: 'SEK 80K–180K/yr',    work: 'Unrestricted',         psv: 'Job Seeker (6 months)',       pr: 'Permanent Residence',      imgFlag: '/flags/btn_sweden.png' },
                  { name: 'New Zealand', tuition: 'NZD $22K–$35K/yr',   work: '20 hrs/week',          psv: 'Post-Study Work (3 yrs)',     pr: 'Skilled Migrant Category', imgFlag: '/flags/btn_new_zealand.png' },
                ].map((row, i) => (
                  <tr key={row.name} className={`border-t border-gray-100 hover:bg-teal/3 transition-colors ${i % 2 === 0 ? 'bg-white' : 'bg-gray-50/40'}`}>
                    <td className="px-5 py-4">
                      <div className="flex items-center gap-2.5 font-bold text-navy">
                        {row.imgFlag ? (
                          <img src={row.imgFlag} alt={row.name} className="w-8 h-8 rounded-md object-cover flex-shrink-0" />
                        ) : (
                          <span className="text-lg">{row.flag}</span>
                        )}
                        {row.name}
                      </div>
                    </td>
                    <td className="px-5 py-4 text-gray-500 text-xs">{row.tuition}</td>
                    <td className="px-5 py-4 text-gray-500 text-xs">{row.work}</td>
                    <td className="px-5 py-4 text-gray-500 text-xs">{row.psv}</td>
                    <td className="px-5 py-4">
                      <span className="text-xs font-semibold text-teal bg-teal/10 px-2.5 py-1 rounded-full">{row.pr}</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <p className="text-center text-xs text-gray-400 py-3 px-4 bg-gray-50 border-t border-gray-100">
              * Figures are approximate and subject to change. Consult our team for current information.
            </p>
          </div>
        </div>
      </section>

      <CTASection
        title="Not Sure Which Country Is Right for You?"
        subtitle="Our counselors compare your profile, budget, and career goals across all destinations — and give you an honest recommendation."
        setPage={setPage}
      />
    </div>
  );
}
